/**
 * v0.9.9a item 3 — how the card / summary refer to the chosen point.
 *  - the user pressed 💧 and shared their real location (GPS) → "บ้านคุณ" / "ใกล้คุณ" …
 *  - a searched place, a tap on the map, a shared link → "จุดนี้" / "ใกล้จุดนี้" …
 * main.ts sets it on every analyse; every text that names the point reads it from here.
 */
let home = false;
export function setPointIsHome(isGps: boolean): void { home = isGps; document.body.dataset.point = isGps ? "home" : "picked"; }
export const pointIsHome = (): boolean => home;
/** "บ้านคุณ" | "จุดนี้" */
export const placeWord = (): string => (home ? "บ้านคุณ" : "จุดนี้");
/** "ใกล้คุณ" | "ใกล้จุดนี้" */
export const nearWord = (): string => (home ? "ใกล้คุณ" : "ใกล้จุดนี้");
/** "ห่างคุณ" | "ห่างจุดนี้" */
export const awayWord = (): string => (home ? "ห่างคุณ" : "ห่างจุดนี้");
/** "จุดคุณ" | "จุดนี้" (e.g. "ถึงจุดคุณ" / "ถึงจุดนี้") */
export const spotWord = (): string => (home ? "จุดคุณ" : "จุดนี้");
